<template>
  <div>
    <v-card v-if="!hideIcon" class="pa-3 mr-4" style="width: 48px; height: 48px; text-align: center; float: left;">
      <slot name="icon">
        <v-icon color="fin-color-primary-dark">icon-tools</v-icon>
      </slot>
    </v-card>

    <div style="height: 48px;">
      <h5 :style="{lineHeight: showType ? '24px' : '48px', fontSize: '16px'}"
          class="shortenedText">
        {{ value.name }}
      </h5>
      <div class="d-flex">
        <p v-if="showType" class="type" style="line-height: 24px;">{{ value.type }}</p>
        <fin-lexicon-link v-if="isInactiveShare"
                          icon="mdi-minus-circle"
                          to="inaktives-wertpapier"/>
      </div>
    </div>
  </div>
</template>

<script>
import FinLexiconLink from "@/components/common/lexicon/LexiconLink"

/** Generic display for different tools */
export default {
  name: "fin-tool-display",
  components: {
    FinLexiconLink
  },
  props: {
    /** The tool object to display */
    value: {
      type: Object,
      default: null
    },
    /** If the type of the tool should be shown */
    showType: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isInactiveShare() {
      if (this.value.share) {
        return !this.value.share.active || !this.value.share.covered || this.value.share.delisted
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h5 {
  font-family: $body-font-family;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.type {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
  color: $fin-color-cool-grey;
}

.shortenedText {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
